import moment from 'moment';

export const weekdays = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];

export const dayInTZ = (date, format = 'DD-MM-YYYY') =>
  moment(date).tz('America/Bogota').format(format);

export const EVENT_DATETIME_FORMAT = 'dddd DD [de] MMMM hh:mm a';

export function generateTimeArray(startTime = 0, endTime = 24) {
  const times = [];
  for (let hour = startTime; hour < endTime; hour++) {
    for (let minute = 0; minute < 60; minute += 15) {
      const formattedHour = hour.toString().padStart(2, '0');
      const formattedMinute = minute.toString().padStart(2, '0');
      times.push(`${formattedHour}:${formattedMinute}`);
    }
  }
  return times;
}

export function addHours(hours, time = new Date()) {
  let d = new Date(time);
  return d.setTime(d.getTime() + hours * 60 * 60 * 1000);
}

export const age = (birthdate) => moment().diff(birthdate, 'years');

export const getThisSemesterRangeOrDates = (startDate, endDate) => {
  const today = moment();
  let defaultStartDate = moment().startOf('year');
  if (today.format('M') >= 7) {
    defaultStartDate = moment().startOf('year').add(6, 'months');
  }
  const from_date = startDate ? moment(startDate).startOf('day') : defaultStartDate;
  const to_date = endDate ? moment(endDate).endOf('day') : today;
  return { from_date, to_date };
};
